import React, { Component } from 'react'
import moment from 'moment'
import { Button } from 'antd'
import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'
import { connect } from '../../../redux/index'
import DailyReport from '../DailyReport/DailyReport'
import InvalidDate from './invalidDate'
import { arrayDivideIntoChunk, notification } from '../../../services'
import './style.css'

@connect(({ report }) => ({ report }))
export class index extends Component {
  state = {
    saveLoading: false,
    date: moment(),
    floor: 'all',
  }

  componentDidMount() {
    const { search, dispatch } = this.props
    if (search) {
      const urlParams = new URLSearchParams(search)
      const [uniqueId, fileName, floor] = [
        urlParams.get('unique_id'),
        urlParams.get('fileName'),
        urlParams.get('floor'),
      ]
      if (floor) this.setState({ floor })
      dispatch({
        type: 'report/GET_OPEN_DAILY_REPORT',
        payload: {
          unique_id: uniqueId,
          fileName,
        },
      })
    }
  }

  disableScroll = () => {
    window.addEventListener('DOMMouseScroll', this.preventDefaultCustom, { passive: false })
    document.addEventListener('wheel', this.preventDefaultCustom, { passive: false }) // Disable scrolling in Chrome
  }

  enableScroll = () => {
    window.removeEventListener('DOMMouseScroll', this.preventDefaultCustom, false)
    document.removeEventListener('wheel', this.preventDefaultCustom, false) // Enable scrolling in Chrome
  }

  onSave = (arrayOfPages, info) => {
    const { date } = this.state
    let fileNameToBeExported = `Daily-Report-${date.format('MM-DD-YYYY')}.pdf`
    if (info.name) {
      fileNameToBeExported = `Daily-Report-${info.name}-${date.format('MM-DD-YYYY')}.pdf`
    }
    this.setState({
      saveLoading: true,
    })
    this.disableScroll()
    window.scrollTo(0, 0)
    try {
      const toImage = []
      /* eslint-disable */
      const pdf = new jsPDF('p', 'mm', 'a4')
      const width = pdf.internal.pageSize.getWidth()
      const height = pdf.internal.pageSize.getHeight()
      arrayOfPages.map((item, index) => {
        const printableMaindiv = document.getElementById(`printableDiv_page${index}`)
        printableMaindiv.classList.remove('widthFull')
        const headerDivPage = document.getElementById(`headerDiv_page${index}`)
        headerDivPage.classList.remove('widthFull')
        const DailyInfoDivPage = document.getElementById(`DailyInfoDiv_page${index}`)
        DailyInfoDivPage.classList.remove('widthFull')
        const DailyInfoCardPage = document.getElementById(`DailyInfoCard_page${index}`)
        DailyInfoCardPage.classList.remove('widthFull')
        const footerDivPage = document.getElementById(`footerDiv_page${index}`)
        footerDivPage.classList.remove('widthFull')
        html2canvas(document.querySelector(`#printableDiv_page${index}`), { scale: 2 })
          .then((canvas) => {
            toImage.push(canvas.toDataURL('image/jpg'))
            // window.log('demo demo', toImage, arrayOfPages.length)
            if (index == arrayOfPages.length - 1) {
              toImage.map((singleImage, subIndex) => {
                pdf.addImage(singleImage, 'JPG', 0, 0, width, height, '', 'FAST')
                if (subIndex !== toImage.length - 1) {
                  pdf.addPage()
                }
              })

              pdf.save(fileNameToBeExported)
              this.setState({
                saveLoading: false,
              })
              this.enableScroll()
              return true
            }
          })
          .catch((e) => {
            window.log(`Error generating Html2pdf in printableDiv_page${index + 1}`, e)
            notification.warning({
              message: 'Error Saving Report',
              description: `Something went wrong while saving report (Errorp${index + 1}).`,
            })
            this.setState({
              saveLoading: false,
            })
            this.enableScroll()
          })
        printableMaindiv.classList.add('widthFull')
        headerDivPage.classList.add('widthFull')
        DailyInfoDivPage.classList.add('widthFull')
        DailyInfoCardPage.classList.add('widthFull')
        footerDivPage.classList.add('widthFull')
      })
      /* eslint-enable */
    } catch (e) {
      window.log('Error generating Html2pdf in printableDiv', e)
      notification.warning({
        message: 'Error Saving Report',
        description: 'Something went wrong while saving report (Errorp1).',
      })
      this.setState({
        saveLoading: false,
      })
      this.enableScroll()
    }
  }

  render() {
    const {
      report: { openDailyReports, loading },
    } = this.props
    const { saveLoading, floor } = this.state
    const reportDate =
      openDailyReports.data && openDailyReports.data.length > 0
        ? moment(openDailyReports.data[0].tracker_ts)
        : moment()
    const chunkedArray = arrayDivideIntoChunk(openDailyReports.data, 20)
    const clinicObj = { name: openDailyReports.info ? openDailyReports.info.clinic_name : '' }
    return (
      <div className="mx-auto">
        {openDailyReports.data && openDailyReports.data.length > 0 ? (
          <>
            <div className="card m-0">
              <div className="card-body">
                <div className="row">
                  <div className="col-12">
                    <h3>
                      <strong>Clinical Reports</strong>
                      <Button
                        className="mr-2"
                        type="primary"
                        icon="file-pdf"
                        loading={saveLoading}
                        style={{ float: 'right' }}
                        disabled={chunkedArray.length === 0 && true}
                        htmlType="button"
                        onClick={() => {
                          this.onSave(chunkedArray, clinicObj)
                        }}
                      >
                        Save as PDF
                      </Button>
                    </h3>
                  </div>
                </div>
              </div>
            </div>
            <DailyReport
              userClinic={clinicObj}
              floor={floor}
              chunkedArray={chunkedArray}
              reportDate={reportDate}
              fullwidthClass="widthFull"
            />
          </>
        ) : (
          <InvalidDate loading={loading} />
        )}
      </div>
    )
  }
}

export default index
